
import { useSelector } from "react-redux";
import { selectShow } from "../../app/selectors";
import store from "../../app/store";
import { setShow } from "../../utils/utilsSlice";
import styles from "../styles/hamburguer.module.scss";

interface MenuToggleProps {
  hidden?: boolean;
}

export const MenuToggle = (props: MenuToggleProps) => {
  const show = useSelector(selectShow);

  const handleMenu = () => {
    store.dispatch(setShow(!show));
  };

  return (
    <button className={`${styles.c_hamburguer}`} onClick={handleMenu} {...props} aria-label="MenuToggle">
      <span className={`${styles.c_hamburguer__arrow}`} hidden={!show}>
        <svg
          width="5"
          height="8"
          viewBox="0 0 5 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.625 6.625L1.37318 4L3.625 1.375"
            strokeWidth="2.5"
            strokeLinecap="round"
            stroke="#fff"
            strokeLinejoin="round"
          />
        </svg>
      </span>
      <span className={`${styles.c_hamburguer__item}`}></span>
    </button>
  );
};

